function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { // HomeOutlined,
InboxOutlined, // MoreHoriz,
TodayOutlined, NodeTree, MenuOutlined, PriorityHighOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import AppMoreMenu from "../AppMoreMenu";
import BottomNavigationButton from "./BottomNavigationButton";
const BottomNavigationWrapper = styled(Flex)`
  position: sticky;
  bottom: 0;
  margin-top: auto;
  z-index: 6;

  ${media.up("medium", "pointer")} {
    display: none;
  }
`;
const BottomNavigation = ()=>{
    const currentUser = useCurrentUser();
    // const startPage = currentUser?.userSetting?.startPage;
    const unreadNotificationCount = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.unreadNotificationCount) || undefined;
    const menuState = useMenuState();
    // const { myTasksURL } = useSpecialTopic();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(BottomNavigationWrapper, {
                height: "96px",
                alignItems: "center",
                justifyContent: "center",
                bg: "#FDF6F0",
                children: [
                    /*#__PURE__*/ _jsx(BottomNavigationButton, {
                        label: "",
                        icon: TodayOutlined,
                        to: "/agenda"
                    }),
                    /*#__PURE__*/ _jsx(BottomNavigationButton, {
                        label: "",
                        icon: PriorityHighOutlined,
                        to: "/priorities"
                    }),
                    /*#__PURE__*/ _jsx(BottomNavigationButton, {
                        label: "",
                        icon: NodeTree,
                        to: "/home"
                    }),
                    /*#__PURE__*/ _jsx(BottomNavigationButton, {
                        badge: unreadNotificationCount,
                        label: "",
                        icon: InboxOutlined,
                        to: "/notifications"
                    }),
                    /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                        children: /*#__PURE__*/ _jsx(BottomNavigationButton, {
                            label: "",
                            icon: MenuOutlined
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx(AppMoreMenu, _objectSpread({}, menuState))
        ]
    });
};
export default BottomNavigation;
